var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('select', {
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("最近一個月")]), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("最近三個月")]), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("最近六個月")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }